import React from "react";
import { Button } from "reactstrap";

const Buttons = ({
  currentPage,
  handleCancelAnnotation,
  handleCancelFirst,
  handleProceed,
  handleStart,
  handleStop,
  handleCancel,
  handleProceedLast,
  handleSubmit,
  result,
  modalLoading,
  allDevicesReady,
  toggle,
  checks,
}) => {

  // Check if any warnings are present that should disable the buttons
  const hasWarnings = checks.hasWarning;

   // Determine if the button should be disabled
   const isButtonDisabled = (page) => {
    switch(page) {
      case 1: // Setup Recording
        return modalLoading || hasWarnings;
      case 2: // Before Recording
        return modalLoading || !allDevicesReady ;
      case 3: // During Recording
        return modalLoading;
      default:
        return modalLoading;
    }
  };

  if (currentPage === 0) {
    return (
      <div className="ml-auto">
        <Button className="m-1" color="secondary" onClick={handleCancelAnnotation}>
          Cancel
        </Button>
      </div>
    );
  }


  return (
    <div className="ml-auto">
      {currentPage === 1 && (
        <>
          <Button className="m-1" color="secondary" onClick={handleCancelFirst}>
            Cancel
          </Button>
          <Button
            className="m-1"
            color="primary"
            onClick={handleProceed}
            disabled={isButtonDisabled(currentPage)}
          >
            Proceed
          </Button>
        </>
      )}
      {currentPage === 2 && (
        <>
          <Button className="m-1" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            className="m-1"
            color="primary"
            onClick={handleStart}
            disabled={isButtonDisabled(currentPage)}
          >
            Start
          </Button>
        </>
      )}
      {currentPage === 4 && (
        <Button className="m-1" color="primary" onClick={handleProceedLast}>
          Proceed
        </Button>
      )}
      {currentPage === 5 && result && (
        <Button className="m-1" color="secondary" onClick={toggle}>
          Close
        </Button>
      )}
      {currentPage === 5 && !result && (
        <Button className="m-1" color="primary" onClick={handleSubmit}>
          Confirm
        </Button>
      )}
      {![1, 2, 4, 5].includes(currentPage) && (
        <Button className="m-1" color="danger" onClick={handleStop} >
          Stop
        </Button>
      )}
    </div>
  )
}

export default Buttons
